import { DocumentType } from '../../constants/Enums';
/* eslint-disable complexity */
const getDefaultSEOData = ({
  document,
  defaultLang,
  defaultTitle,
  siteUrl,
  isWebsiteDocument,
}) => ({
  title: document.data?.title?.text || defaultTitle,
  description: document.data?.meta_description || '',
  ogDescription:
    document.data?.og_description || document.data?.meta_description || '',
  image: document.data?.illustration?.thumbnails?.SEO?.url || '',
  imageAlt: document.data?.illustration?.thumbnails?.SEO?.alt || '',
  url: isWebsiteDocument
    ? `${siteUrl}${
        defaultLang === document.lang ? '' : `/${document.lang?.slice(0, 2)}`
      }`
    : `${siteUrl}${document.url || ''}`,
  lang: document.lang?.substring(0, 2) || defaultLang,
  firstPublicationDate: document.first_publication_date || '',
  lastPublicationDate: document.last_publication_date || '',
});

export const getSEOData = ({
  document,
  defaultDocument,
  title,
  siteUrl,
  isArticle,
  parents,
}) => {
  const { type: documentType } = document || '';
  const isWebsiteDocument =
    documentType === DocumentType.PAGE ||
    documentType === DocumentType.EVENTGALLERY ||
    documentType === DocumentType.EVENTTAG ||
    documentType === DocumentType.EVENT ||
    '';
  const defaultTitle = defaultDocument?.data?.meta_title || 'Wooclap';
  const defaultLang = isWebsiteDocument ? 'en-gb' : 'fr-fr';
  const defaultData = getDefaultSEOData({
    document: defaultDocument,
    defaultLang,
    defaultTitle,
    siteUrl,
    isWebsiteDocument,
  });

  const parentLength = parents?.length;
  const categoryUrl = parents?.[parentLength - 1]?.parentUid || '';
  const categoryName = parents?.[parentLength - 1]?.parentName || '';

  return {
    title: title || defaultData.title,
    description: document.data?.meta_description || defaultData.description,
    ogDescription:
      document.data?.og_description ||
      document.data?.meta_description ||
      defaultData.ogDescription,
    image:
      document.data?.illustration?.thumbnails?.SEO?.url || defaultData.image,
    imageAlt:
      document.data?.illustration?.thumbnails?.SEO?.alt || defaultData.imageAlt,
    defaultUrl:
      defaultData.url || isWebsiteDocument
        ? 'https://www.wooclap.com/'
        : 'https://www.wooclap.com/blog/',
    defaultTitle,
    url: `${siteUrl}${document.url || ''}`,
    lang: document.lang?.substring(0, 2) || defaultData.lang,
    firstPublicationDate:
      document.first_publication_date || defaultData.firstPublicationDate,
    lastPublicationDate:
      document.last_publication_date || defaultData.lastPublicationDates,
    // eslint-disable-next-line no-nested-ternary
    categoryName: parents
      ? categoryName || ''
      : isArticle
      ? document.data?.category?.document?.data?.category_name || ''
      : '',
    // eslint-disable-next-line no-nested-ternary
    categoryUrl: parents
      ? `${
          defaultLang === document.lang ? '' : `/${document.lang?.slice(0, 2)}`
        }/${categoryUrl}` || ''
      : isArticle
      ? document.data?.category?.url || ''
      : '',
  };
};
